/* 证书字段接口 */
import { axios } from '@/utils/http'

/**
 * 获取用户的证书字段配置和值
 */
export const getUserFieldConfigs = (params) => axios({
  method: 'GET',
  hastoken: true,
  contentType: 'urlencoded'
}, '/competition/certificate/field-value/getUserFieldConfigs?' + new URLSearchParams(params).toString())

/**
 * 保存用户的证书字段值
 */
export const saveUserFieldValues = (data) => axios({
  method: 'POST',
  contentType: 'json',
  data: data,
  hastoken: true
}, '/competition/certificate/field-value/saveUserFieldValues')

